import { Media } from "@Utilities/Media";
import { ReadMore } from "@Utilities/ReadMore";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import enquire from "enquire.js";

interface IVisualFilter
{
	ToggleButton: HTMLElement;
	LessToggle: HTMLElement;
	MoreToggle: HTMLElement;
	MobileOff: NodeListOf<HTMLElement>;
	DesktopOff: NodeListOf<HTMLElement>;
	AllLinks: NodeListOf<HTMLElement>;
}

export class BaseCategory
{
	public FilterEl: HTMLElement;
	public DesktopFilterEl: HTMLElement;
	public MobileFilterEl: HTMLElement;
	public MobileFilterContainer: HTMLElement;
	public MobileFilterInstance: Offcanvas;
	public OffCanvasLibrary: Offcanvas;
	public RefreshTest = document.querySelector(".catRefresh") !== null;
	public VisualFilters: IVisualFilter[];

	constructor()
	{
		const noResultsPage = (document.querySelector(".no-srch-rslt") !== null);
		const splitSearchPage = (document.querySelector(".split") !== null);

		if (!noResultsPage && !splitSearchPage)
		{
			this.Initialize();
		}
	}

	public Initialize(): void
	{
		this.CountTopRow();
		this.ConfigureFilter();
		this.ConfigureReadMore();
		this.ConfigureVisualFilters();

		enquire.register(Media.MediaMobile, {
			deferSetup: true,
			match: () =>
			{
				this.MobileFilterSetup();
				this.MobileSortSetup();
			},
			unmatch: () =>
			{
				this.MobileFilterDestroy();
				this.MobileSortDestroy();
			}
		});
	}

	public ConfigureFilter = (): void =>
	{
		this.FilterEl = document.getElementById("filter");
		this.DesktopFilterEl = document.getElementById("desktopFilter");
		this.MobileFilterEl = document.getElementById("mobileFilter");
		this.MobileFilterContainer = document.getElementById("offcanvasFilter");
		this.MobileFilterInstance = Offcanvas.getOrCreateInstance(this.MobileFilterContainer);
	};

	public ConfigureReadMore = (): void =>
	{
		const readClamp: NodeListOf<HTMLElement> = document.querySelectorAll(".readClamp");

		if (readClamp.length > 0)
		{
			readClamp.forEach(clamp =>
			{
				new ReadMore(clamp);
			});
		}
	};

	public ConfigureVisualFilters = (): void =>
	{
		this.VisualFilters = [];
		const visualFilters = document.querySelectorAll(".visual") as NodeListOf<HTMLElement>;

		if (visualFilters.length > 0)
		{
			visualFilters.forEach((visualFilter: HTMLElement, index: number) =>
			{
				const filterConfig: IVisualFilter = {
					ToggleButton: visualFilter.querySelector(".visual__toggle") as HTMLElement,
					LessToggle: visualFilter.querySelector(".visual__less") as HTMLElement,
					MoreToggle: visualFilter.querySelector(".visual__more") as HTMLElement,
					MobileOff: visualFilter.querySelectorAll(".visual__bubble--m-off") as NodeListOf<HTMLElement>,
					DesktopOff: visualFilter.querySelectorAll(".visual__bubble--d-off") as NodeListOf<HTMLElement>,
					AllLinks: visualFilter.querySelectorAll(".visual__bubble") as NodeListOf<HTMLElement>
				};

				this.VisualFilters.push(filterConfig);

				const toggleButton = this.VisualFilters[index].ToggleButton;

				if (toggleButton !== null)
				{
					toggleButton.addEventListener("click", (e) =>
					{
						this.ToggleVisualFilter(e, this.VisualFilters[index]);
					});
				}
			});
		}
	};

	/// <summary>Counts the number of columns in the first row of products.</summary>
	public CountTopRow = (): void =>
	{
		let columns = 0;
		const resultsContainer = document.querySelector(".results");
		const currentCount = parseInt(resultsContainer.getAttribute("data-cols"), 10);
		const results = document.querySelectorAll(".results > div") as NodeListOf<HTMLElement>;

		if (results !== null && results.length > 0)
		{
			for (const column of results)
			{
				const previous = column.previousElementSibling as HTMLElement;

				if (previous !== null)
				{
					if (column.offsetTop !== previous.offsetTop)
					{
						break;
					}

					columns++;
				}

				else
				{
					columns++;
				}
			};
		}

		if (columns !== currentCount)
		{
			if (resultsContainer !== null)
			{
				resultsContainer.setAttribute("data-cols", columns.toString());
				this.AddFiller(columns);
			}
		}
	};

	public MobileFilterDestroy = (): void =>
	{
		this.DesktopFilterEl.innerHTML = this.FilterEl.outerHTML;
		this.MobileFilterEl.innerHTML = "";
		this.MobileFilterInstance.hide();
	};

	public MobileFilterSetup = (): void =>
	{
		this.MobileFilterEl.innerHTML = this.FilterEl.outerHTML;
		this.DesktopFilterEl.innerHTML = "";
	};

	public MobileSortSetup = (): void =>
	{
	};

	public MobileSortDestroy = (): void =>
	{
	};

	public AddFiller(columns): void
	{
	};

	private ToggleVisualFilter = (e: Event, filterConfig: IVisualFilter): void =>
	{
		e.preventDefault();

		if (filterConfig.MoreToggle !== null)
		{
			const expand = filterConfig.MoreToggle.offsetParent !== null;

			if (expand)
			{
				filterConfig.MoreToggle.style.display = "none";
				filterConfig.LessToggle.style.display = "";

				filterConfig.AllLinks.forEach((link) =>
				{
					if (link.offsetParent === null)
					{
						link.style.display = "block";
					}
				});
			}
			else
			{
				let linksToHide: NodeListOf<HTMLElement>;

				filterConfig.MoreToggle.style.display = "";
				filterConfig.LessToggle.style.display = "none";

				if (Media.IsMobile)
				{
					linksToHide = filterConfig.MobileOff;
				}
				else
				{
					linksToHide = filterConfig.DesktopOff;
				}

				linksToHide.forEach((link) =>
				{
					link.style.display = "none";
				});
			}
		}
	};
}